import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  CircularProgress
} from '@mui/material';
import ApiFetch from '../ApiFetch';
import { LoginInfo } from '../../App';
import Thumb from '../common/Thumb';

// モデルIDを指定してサンプル画像を表示するコンポーネント
const ModelSampleGallery = ({ modelId }) => {
  const [model, setModel] = useState(null);
  const [samples, setSamples] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { loginInfo } = useContext(LoginInfo);

  // モデル情報を取得
  const getModelInfo = async (id) => {
    console.log(id)
    try {
      const response = await new ApiFetch().get(
        `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/model/modelList`
      );
      const json = await response.json();
      if (json.result) {
        const foundModel = json.data.find(m => m.model_id === id);
        if (foundModel) {
          setModel(foundModel);
          return foundModel;
        }
      }
      return null;
    } catch (error) {
      console.error('Error fetching model info:', error);
      return null;
    }
  };

  // サンプル画像を取得
  const getSampleImages = async (model, modelId) => {
    try {
      const response = await new ApiFetch().post(
        `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/image/modelSamples`,
        { model, modelId }
      );
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Error fetching sample images:', error);
      return { result: false, data: [] };
    }
  };

  useEffect(() => {
    const loadData = async () => {
      if (!modelId) return;
      
      setIsLoading(true);
      const modelInfo = await getModelInfo(modelId);
      
      if (modelInfo) {
        const samplesResponse = await getSampleImages(modelInfo.i_name, modelInfo.id);
        if (samplesResponse.result && samplesResponse.data.length > 0) {
          setSamples([...samplesResponse.data]);
        } else {
          setSamples([]);
        }
      }
      
      setIsLoading(false);
    };
    
    loadData();
  }, [modelId]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!model) {
    return <Typography>モデルが見つかりません</Typography>;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', py: 4 }}>
      <Grid container spacing={2}>
        {samples.length === 0 ? (
          <Typography>画像がありません</Typography>
        ) : (
          samples.map((data, i) => {
            if (data.mute === 1 || (i > 0 && samples?.[i - 1]?.user_id === data.user_id) ||
              (data.user_id !== loginInfo.userId && data.search_ban === 1)) {
              return <span data-no={i} className="lazy" key={i}></span>;
            }
            return (
              <Thumb
                data={data}
                i={i}
                key={i}
                list={samples.filter(d => d.mute === 0)}
                listName={"samples"}
              />
            );
          })
        )}
      </Grid>
    </Box>
  );
};

export default ModelSampleGallery;